import axios from "axios";

export const TOKEN_KEY = "token";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "/api",
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Expired / invalid token -> tell AuthContext to log out.
// (Login itself returns 401 for wrong credentials, so it's excluded.)
api.interceptors.response.use(
    (res) => res,
    (error) => {
        const status = error.response?.status;
        const url: string = error.config?.url || "";

        if (status === 401 && !url.includes("/auth/login") && localStorage.getItem(TOKEN_KEY)) {
            window.dispatchEvent(new Event("auth:logout"));
        }

        return Promise.reject(error);
    }
);

export default api;